import { createContext, ReactNode } from 'react';

export interface GTMContextType {
  trackEvent: (eventName: string, properties?: Record<string, any>) => void;
}

enum GTMEvents {
  API_ERROR = 'erro_api',
  DOWNLOAD_TICKET = 'btn_baixar_boleto',
  COPY_TICKET = 'btn_copiar_codigo_boleto',
  COPY_PIX = 'btn_copiar_codigo_pix',
  ENTRY_TICKET_GENERATED = 'boleto_entrada_gerado',
  SESSION_EXPIRED = 'sessao_expirada',
  EMAIL_VALIDATION_ERROR = 'erro_validacao_de_email',
  DOWNLOAD_APP = 'btn_baixar_app',
  BACK_TO_GOL = 'btn_voltar_para_gol',
  SEND_EMAIL_VALIDATION = 'enviou_validacao_de_email',
  VIEW_EMAIL_VALIDATION = 'visualizou_validacao_de_email',
  REVIEW_INSTALLMENTS = 'revisao_parcelas',
  VIEW_FAQ = 'como_funciona_o_boleto_parcelado_pagol',
  VIEW_CCB = 'visualizou_ccb_cedula_de_credito_bancaria',
  VIEW_PRIVACY_POLICY = 'politica_privacidade',
  VIEW_TERMS = 'termos_e_condicoes_do_boleto_parcelado_pagol',
  SELECT_INSTALLMENTS = 'selecionou_parcelas',
  VIEW_INSTALLMENTS = 'visualizou_parcelas',
  VIEW_ONBOARDING = 'visualizou_onboarding_animado',
  USER_REPROVED = 'usuario_reprovado',
  IDWALL_QUERY = 'consultando_dados',
  IDWALL_TIMEOUT = 'timeout_idwall',
  IDWALL_RETRY = 'btn_tentar_novamente',
}

const GTMContext = createContext<GTMContextType | undefined>(undefined);

const environment = import.meta.env.VITE_NODE_ENV;

const canNot = () => {
  return environment === 'development';
};

const GTMProvider = ({ children }: { children: ReactNode }) => {
  const trackEvent = (event: GTMEvents, properties?: Record<string, any>) => {
    if (canNot()) return;

    if (typeof window !== 'undefined') {
      window['dataLayer'].push({
        event,
        environment,
        ...properties,
      });
    }
  };

  return (
    <GTMContext.Provider value={{ trackEvent }}>{children}</GTMContext.Provider>
  );
};

export { GTMProvider, GTMContext, GTMEvents };
